// @tc-check
import Icon from 'components/base/Icon';
import Checkbox from 'components/base/Checkbox';
import some from 'lodash/some';
import { getMultiLevelMenuItemClasses } from '../../Dropdown/common-styles';
import {
  StyledMenuItem,
  StyledMenuItemWrapper
} from './ListItemRenderer.style';
import { Flex } from 'components/base/layout-components';

export const ListItemRenderer = props => {
  const { index, style, data } = props;
  const {
    selected,
    multiple,
    isDisableChildrenOfSelectedParent,
    disabled,
    isMaxLimit,
    openedParents,
    selectedPathIds,
    isSearchMode,
    dataAttrName,
    optionActions,
    classes,
    onOptionClick,
    onOpenMenuClick,
    handleCloseMenus,
    handleClearSearch
  } = data;
  const option = data?.options[index];
  const isClickable = option?.isClickable ?? true;

  const {
    value,
    displayValue,
    ignoreMaxLimit,
    searchResultDisplayValue = displayValue,
    hasSeperator,
    children = [],
    path = []
  } = option;
  const isParent = children.length > 0;
  const isSelected = selected.includes(value);
  const isChildOfSelectedParent = some(
    path.map(({ id }) => id),
    id => selected.includes(id)
  );
  const isDisableChildOfSelectedParent =
    isDisableChildrenOfSelectedParent && isChildOfSelectedParent;
  const isDisabled =
    disabled.includes(value) || (isMaxLimit && !isSelected && !ignoreMaxLimit);
  const isOpenedParent = openedParents
    .map(({ value }) => value)
    .includes(value);
  const isChildSelected = selectedPathIds[value];
  const isShowOpenMenuArrow = isParent && !isSearchMode;
  const displayValueMaxWidth = multiple
    ? `calc(100% - 5rem)`
    : `calc(100% - 2rem)`;

  return (
    <StyledMenuItemWrapper style={style} key={index}>
      <StyledMenuItem
        disableRipple
        disableGutters={multiple}
        id={`${value}-picker-item`}
        data-cy={`${dataAttrName}-picker-item`}
        value={value}
        borderBottom={hasSeperator}
        cursor={
          !isClickable || isDisableChildOfSelectedParent ? 'unset' : 'pointer'
        }
        classes={{
          ...getMultiLevelMenuItemClasses({
            classes,
            isSelected,
            isOpenedParent: isOpenedParent || isChildSelected,
            multiple
          })
        }}
        onClick={
          isClickable
            ? () => {
                !isDisableChildOfSelectedParent && onOptionClick(option);
              }
            : null
        }
        disabled={isDisabled}
        {...(!isSearchMode && {
          onMouseOver: event => {
            event.persist();
            clearTimeout(window.myTimeout);
            window.myTimeout = setTimeout(() => {
              if (isParent) {
                event.stopPropagation();
                onOpenMenuClick(option);
              }
            }, 500);
          }
        })}
      >
        <Flex width='90%'>
          {multiple && (
            <Checkbox
              checked={isSelected || isDisableChildOfSelectedParent}
              indeterminate={isChildSelected && !isSelected}
              disabled={isDisableChildOfSelectedParent}
            />
          )}
          <Flex items='center' grow='1' maxWidth={displayValueMaxWidth}>
            {isSearchMode ? searchResultDisplayValue : displayValue}
          </Flex>
        </Flex>
        {optionActions.map((action, idx) => {
          const rightPosition = isShowOpenMenuArrow ? '3rem' : '1rem';
          return (
            <Flex
              key={idx}
              position='absolute'
              style={{ right: rightPosition }}
              onClick={event => {
                event.stopPropagation();
                handleCloseMenus();
                handleClearSearch();
              }}
            >
              {action(option)}
            </Flex>
          );
        })}
        {isShowOpenMenuArrow && (
          <Flex
            cursor='pointer !important'
            onClick={event => {
              event.stopPropagation();
              onOpenMenuClick(option);
            }}
          >
            <Icon name='ChevronRight' size='medium' color='shuttleGray' />
          </Flex>
        )}
      </StyledMenuItem>
    </StyledMenuItemWrapper>
  );
};
